import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { WorkflowService } from "src/app/_services/workflow.service";
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserMgmtService } from 'src/app/_services/user-mgmt.service';
import { UserService } from 'src/app/_services/user.service';
import { ToastrService } from 'ngx-toastr';
import { error } from 'console';
import { ActivatedRoute } from '@angular/router';
import { WfTemplateComponent } from '../wf-template/wf-template.component';

@Component({
  selector: 'app-workflow-dashboard',
  templateUrl: './workflow-dashboard.component.html',
  styleUrls: ['./workflow-dashboard.component.scss']
})
export class WorkflowDashboardComponent implements OnInit {

  searchString: string = '';
  groupList : any = [];
  groupListCopy: any = [];
  showDisabled: boolean = false;
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  addWorkFlowGroupForm: FormGroup;
  editWorkFlowGroupForm: FormGroup;
  startNodeForm: FormGroup;
  dropdownSettings = {};
  selectedItems: any = [];
  editSelectedItems: any = [];
  masterUsers: any = [];
  customerList: any = [];
  currentUser: any;
  userList: any = [];
  isFormChanged: any;
  enableUserList: boolean = false;
  isSelectedGroupDisabled :  boolean = false;
  selectedGroupForEdit: any;
  sortColumn: string = 'updatedAt';
  sortDirection: 'asc' | 'desc' = 'asc';
  selectedTemplate: any;
  startNodeDetails:  any;
  startNodeFormData: any;

@ViewChild(WfTemplateComponent) wfTemplateComponent!: WfTemplateComponent;

 @ViewChild("randomeClick", null) randomeClick: ElementRef;
 @ViewChild("randomeClick1", null) randomeClick1: ElementRef;
 @ViewChild("closeNewGroupForm", null) closeNewGroupForm: ElementRef;
 @ViewChild("closeEditGroupForm", null) closeEditGroupForm: ElementRef;
 @ViewChild("closeAuditGroup", null) closeAuditGroup: ElementRef;
 @ViewChild('openWfForm', null) openWfForm: ElementRef;
 @ViewChild('preOpenWfForm', null) preOpenWfForm: ElementRef;
 @ViewChild('closeStartTemplateForm', null) closeStartTemplateForm: ElementRef;
 @ViewChild('closePreStartTemplateForm', null) closePreStartTemplateForm: ElementRef;
 
  tabView: string;

  constructor(private workFlowService: WorkflowService,
    private formBuilder: FormBuilder,
    private userManagement: UserMgmtService,
    private userService: UserService,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.loadWorkFlowGroups();
    this.loadCurrentUser();
    this.initAllForms();
    this.editWorkFlowGroupForm.valueChanges.subscribe(() => {
      this.checkIfFormChanged();
    });
    this.activatedRoute.fragment.subscribe((res)=>
      {
        if (!res) {
          this.tabView = 'Work';
          return;
        }
        this.tabView = res;
        switch(res)
        {
          case 'Groups':
            this.setHeader('Groups');
            return;
          case 'Templates':
            this.setHeader('Templates');
            return;
          case 'Work':
            this.setHeader('Work');
            return;
          default:
            this.setHeader('Work'); 
          return;
        }
      })
  }
  setHeader(value) {
    this.tabView = value
    
  }


  initAllForms() {
    this.addWorkFlowGroupForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      description: ['',]
    });

    this.editWorkFlowGroupForm = this.formBuilder.group({
      title: ['', [Validators.required, Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)]],
      description: ['',]
    });

    this.startNodeForm = this.formBuilder.group({
      fields: this.formBuilder.array([])
    });

    this.selectedItems = [];
  }

  checkIfFormChanged() {
    const currentValues = this.editWorkFlowGroupForm.value;
  
    // Check if title or description has changed
    this.isFormChanged =
      currentValues.title.trim() !== this.selectedGroupForEdit.groupName.trim() ||
      currentValues.description.trim() !== (this.selectedGroupForEdit.description || '').trim();
  
    // Check if user selection has changed
    if (!this.isFormChanged) {
      const originalUserIds = new Set(this.selectedGroupForEdit.userIds.map(String)); // Convert to string for safe comparison
      const selectedUserIds = new Set(this.editSelectedItems.map(user => String(user.userId)));
  
      this.isFormChanged = originalUserIds.size !== selectedUserIds.size ||
                           [...selectedUserIds].some(userId => !originalUserIds.has(userId));
    }
  }

  filterGroup()
  {
    console.log("text ",this.searchString);

    let groupCopy = JSON.parse(JSON.stringify(this.groupList));
    if(groupCopy.length == 0)
    {
      return;
    }
   this.groupListCopy =  groupCopy.filter(group => {
        let username =  group.groupName.toLowerCase();
        if(username.includes(this.searchString.toLowerCase()))
        {
          return true;
        }
    });

  }

  showUpdatedList(event)
  {
    this.showDisabled = event;
    console.log(event);
    let groupCopy = JSON.parse(JSON.stringify(this.groupList));
    if(groupCopy.length == 0)
    {
      return;
    }

    if (this.showDisabled) {
      this.groupListCopy = groupCopy.filter(group => {
        return true;
      });
    }
    else {
      this.groupListCopy = groupCopy.filter(group => {
        if (group.enabled) {
          return true;
        }
      });
    }
  }

  onPageChange(newValue) {
    this.selectedPage = newValue;
    this.perpageitem = newValue;
  }

  addWorkflowGroup()
  {

    let groupNameCheck : boolean = false;
    
    this.groupList?.forEach((group)=>
    {
      if(group.groupName.toLowerCase() == this.addWorkFlowGroupForm.value.title.toLowerCase())
      {
        groupNameCheck =  true;
      }
    })

    if(groupNameCheck)
    {
      this.toastrService.clear();
      this.toastrService.warning('Group name already exist')
      return;
    }

    if (!/^[^:|*?<>/\\"]+$/.test(this.addWorkFlowGroupForm.value.title)) {
      this.toastrService.clear();
      this.toastrService.warning('Group name is not Valid')
      return;
    }

    let selectedUserIds =  [];

    this.selectedItems.forEach(element => {
      selectedUserIds.push(element.userId);
    });

    let reqBody = 
    {
      "groupName": this.addWorkFlowGroupForm.value.title,
      "description": this.addWorkFlowGroupForm.value.description,
      "userIds": selectedUserIds,
      "enabled": true
    }

    this.workFlowService.createNewGroup(reqBody, this.currentUser.id).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Group created successfully ");
      this.closeNewGroupForm.nativeElement.click();
      this.loadWorkFlowGroups();
    })
  }

  editWorkFlowGroup(group)
  {
    this.selectedGroupForEdit =  group;
    this.isSelectedGroupDisabled = !group.enabled

    this.editWorkFlowGroupForm.patchValue({
      title: group.groupName,
      description: group.description
    });

    this.editSelectedItems = [];

    group.userIds.forEach(element => {

      this.userList.forEach(user => {
        if(user.userId ==  element)
        {
          this.editSelectedItems.push(user);
        }
      });
    });

    this.isFormChanged = false;
  }

  auditWorkFlowGroup(group)
  {
    this.selectedGroupForEdit =  group;
    console.log("selectedGroup : ", this.selectedGroupForEdit);
    this.isSelectedGroupDisabled = !group.enabled
  }

  enableGroup()
  {
    let reqBody = 
    {
      "groupName": this.selectedGroupForEdit.groupName,
      "description": this.selectedGroupForEdit.description,
      "userIds": this.selectedGroupForEdit.userIds,
      "enabled": true
    }

    this.workFlowService.editWorkFlowGroup(this.selectedGroupForEdit.id ,reqBody, this.currentUser.id).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Group enabled successfully ");
      this.closeAuditGroup.nativeElement.click();
      this.loadWorkFlowGroups();
    })
  }

  saveWorkflowChanges()
  {

    let selectedUserIds: any =  [];

    if (!/^[^:|*?<>/\\"]+$/.test(this.editWorkFlowGroupForm.value.title)) {
      this.toastrService.clear();
      this.toastrService.warning('Group name is not Valid')
      return;
    }

    this.editSelectedItems.forEach((element: any) => {
      selectedUserIds.push(element.userId);
    });

    let reqBody = 
    {
      "groupName": this.editWorkFlowGroupForm.value.title,
      "description": this.editWorkFlowGroupForm.value.description,
      "userIds": selectedUserIds,
      "enabled": !this.isSelectedGroupDisabled
    }

    this.workFlowService.editWorkFlowGroup(this.selectedGroupForEdit.id ,reqBody, this.currentUser.id).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Group updated successfully");
      this.closeEditGroupForm.nativeElement.click();
      this.loadWorkFlowGroups();
    })
  }

  loadCurrentUser()
  {
    this.userService.getUser().subscribe((res)=>
    {
      this.currentUser = res;
      console.log("current user : ", this.currentUser);
      this.loadUsers();
    })
  }

  loadUsers() {
    this.userList = [];

    this.userManagement.loadActiveUsers().subscribe((response: any)=>
    {
      if(response.length > 0)
      {
        response.forEach( u => {
          this.userList.push({ userId: u.id, sharedName: u.name });
        });

        console.log("Users : ", this.userList);
        this.dropdownSettings = {
          singleSelection: false,
          idField: "userId",
          textField: "sharedName",
          selectAllText: "select All",
          unSelectAllText: "Unselect All",
          itemsShowLimit: 5,
          allowSearchFilter: true,
        };
        this.enableUserList = true;
        this.randomeClick.nativeElement.click();

      }
    })
  }

  loadWorkFlowGroups()
  {
    this.workFlowService.getWorkFlowGroups().subscribe((res) => {
      this.groupList = res;
      this.groupList.forEach(element => {
        element['assignedUsers'] = element.userIds?.length
      });
      this.groupListCopy = this.groupList;
      this.showUpdatedList(this.showDisabled);
      this.sortData('updatedAt')
    })
  }

  onItemSelect(item: any) {
    this.checkIfFormChanged();
    console.log(item);
  }

  onSelectAll(items: any) {
    this.checkIfFormChanged();
    console.log(items);
  }

  public onDeSelect(item: any) {
    this.checkIfFormChanged();
    console.log(item);
  }

  public onDeSelectAll(items: any) {
    this.checkIfFormChanged();
    console.log(items);
  }

  getUserById(id)
  { 
    let selectedUser;
    this.userList.forEach(element => {
      if(element.userId == id)
      {
        selectedUser =  element.sharedName
      }
    });

    if(this.currentUser.id == id)
    {
      selectedUser =  this.currentUser.name;
    }

    if(selectedUser == undefined)
    {
      selectedUser = 'Unknown user'
    }

    return selectedUser
  }

  sortData(column: string) {
    this.sortDirection = this.sortColumn === column && this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortColumn = column;
    this.sortDirection === 'asc' ? document.getElementById("sortCol").className = "asc" : document.getElementById("sortCol").className = "desc";
    this.groupListCopy.sort((a, b) => {
      const valueA = a[column as keyof typeof a];
      const valueB = b[column as keyof typeof b];

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return this.sortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      }

      if (valueA instanceof Date && valueB instanceof Date) {
        return this.sortDirection === 'asc' ? +valueA - +valueB : +valueB - +valueA;
      }

      return 0;
    });
  }

  openStartForm(template: any)
  {
    console.log(template);
    this.selectedTemplate = template;

    this.workFlowService.getStartVariables(template.workflow.id).subscribe((res: any)=>
      {
        this.initAllForms();
        
        let response =  res?.inputVariable;
        if(res?.form?.formFields)
        {
          this.startNodeFormData = res?.form;
          this.loadForm(res?.form?.formFields);
        }

        if(response.length != 0)
        {
          response.forEach(element => {
            element['value'] = '';
          });
        }

        this.startNodeDetails = response;

        this.openWfForm.nativeElement.click();
      }, (error: any)=>
      {
        console.log(error);
      })

  }

  executeWorkflow()
  {
    let isFormInvalid =  false
    this.startNodeDetails?.forEach((variable: any) => {
        if(variable.value.trim().length == 0)
        {
          isFormInvalid = true;
        }
    });

    if(isFormInvalid)
    {
      this.toastrService.clear();
      this.toastrService.warning("Please fill the Unique Identifier and try again");
      return;
    }

    let isStartFormValid = this.startNodeForm.valid;
    if (!isStartFormValid) {
      this.toastrService.clear();
      this.toastrService.warning("Please fill the required fields and try again");
      return;
    }

    let body = {};
    this.startNodeDetails?.forEach((variable: any) => {
      body[variable.label] =  variable.value;
    });
    body['workflowId'] =  this.selectedTemplate.workflow.id;

    if(this.startNodeFormData)
      this.startNodeFormData.formFields = this.startNodeForm.value.fields;

    let responseObj =  { "execute": body};

    responseObj['form'] = this.startNodeFormData;

    this.workFlowService.executeTemplate(responseObj).subscribe((res)=>
    {
      this.toastrService.clear();
      this.toastrService.success("Workflow started successfully");
      this.wfTemplateComponent.highLightWorkflow(this.selectedTemplate.workflow.id);
      this.closePreStartTemplateForm.nativeElement.click();
      this.closeStartTemplateForm.nativeElement.click();
      return;
    })
  }

  validateWorkflowIdentifier() {
    // Validating if workflow with same uniqueIdentifier already exist

    const uniqueIdentifier = this.startNodeDetails[0].value;
    const request = {
      uniqueIdentifier : uniqueIdentifier,
      workflowId : this.selectedTemplate.workflow.id
    }
    this.workFlowService.getRunningIdentifier(request).subscribe((res: any)=>{
      console.log("Validated unique Identifier: "+res);
      if(res.length>0) {
        this.closeStartTemplateForm.nativeElement.click();
        this.preOpenWfForm.nativeElement.click();
      } else {
        this.executeWorkflow();
      }
    }, error=>{
      console.log("Unable to validate unique Identifier: "+error);
    });
  }

  openStartWorkFlowModal() {
    this.openWfForm.nativeElement.click();
  }

  get fields() {
    return this.startNodeForm.get('fields') as FormArray;
  }

  loadForm(formData: any) {
    formData.forEach((field: any) => {
      const formGroup = this.createFieldGroup(field);
      this.fields.push(formGroup);
    });
  }

  createFieldGroup(field: any): FormGroup {
    switch (field.fieldType) {
      case 'input':
        return this.formBuilder.group({
          label: [field.label],
          fieldType: [field.fieldType],
          inputType: [field.inputType],
          value: [null, field.required ? Validators.required : null],
          validationMessage: [field.validationMessage],
          variableName: [field.variableName],
          acceptedFileType: [field.acceptedFileType],
          required: [field?.required]
        });
      case 'select':
        return this.formBuilder.group({
          label: [field.label],
          fieldType: [field.fieldType],
          options: [field.options],
          value: [null, field.required ? Validators.required : null],
          validationMessage: [field.validationMessage],
          variableName: [field.variableName],
          required: [field?.required]
        });
      // Add more cases here if needed (e.g., checkbox, date, etc.)
      default:
        return this.formBuilder.group({
          label: [field.label],
          fieldType: [field.fieldType],
          value: [null],
          validationMessage: [field.validationMessage],
          variableName: [field.variableName],
          acceptedFileType: [field.acceptedFileType],
          required: [field?.required]
        });
    }
  }

}
